import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import loginsActions from '../../redux/logins/actions';
import LoginList from '../../components/LoginList';
import SidebarContainer from '../SidebarContainer';
import DealerNav from '../../components/DealerNav';
import ContentPage from '../ContentPage';
import './Logins.scss';

class Logins extends Component {
  componentDidMount() {
    const { dealerId } = this.props.match.params;
    this.props.actions.loginsRequest(dealerId);
  }

  render() {
    const { logins, dealer, actions } = this.props;
    return (
      <SidebarContainer title={dealer.name} logo={dealer.logo}>
        <div className="logins-table">
          <DealerNav />
          <LoginList
            dealer={dealer}
            list={logins.logins}
            error={logins.error}
            fetching={logins.fetching}
            verificationStatus={logins.verificationStatus}
            onDelete={actions.deleteLoginRequest}
            verifyLogin={actions.verifyLoginRequest}
            resetLoginVerification={actions.resetLoginVerification}
            history={this.props.history}
          />
        </div>
      </SidebarContainer>
    );
  }
}

Logins.propTypes = {
  logins: PropTypes.object,
  actions: PropTypes.object,
  dealer: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = ({ logins, dealers }) => ({
  logins,
  dealer: dealers.dealer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...loginsActions,
    },
    dispatch,
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentPage(Logins));
